import { WriterValueType } from '../../enums/file-writer/writer-value-type';
import { XmlElementType } from '../../enums/file-writer/xml-element-type';
import { Guid } from '../guid';

export class XmlWriterMapping {
	id = Guid();
	tagName = 'New Element';
	elementType = XmlElementType.RootElement;
	isRecordNode = false;
	valueType = WriterValueType.Field;
	value = '';
	attributes: XmlWriterMapping[] = [];
	elements: XmlWriterMapping[] = [];

	constructor(init?: Partial<XmlWriterMapping>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
